module.exports = __webpack_public_path__ + "img/myshopping.8e9eb68b.png";